import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/blackberry': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M166 116.9C166 140.3 149.6 166 93.5 166H23.4L44.4 77.2H112.2C154.3 77.2 166 100.5 166 116.9zM292.2 77.2H224.4L205.7 166H275.8C329.6 166 345.9 140.3 345.9 116.9 346 100.5 334.3 77.2 292.2 77.2zM88.8 208.1H21L0 296.9H70.1C126.2 296.9 142.6 273.5 142.6 247.8 142.6 231.5 130.9 208.1 88.8 208.1zM268.9 208.1H201.1L182.4 296.9H252.5C306.3 296.9 322.6 273.5 322.6 247.8 322.6 231.5 310.9 208.1 268.9 208.1zM458.2 154.3H390.4L371.7 243.1H441.8C495.6 243.1 511.9 219.7 511.9 194 512 177.7 500.3 154.3 458.2 154.3zM430.2 292.2H362.4L343.7 381H413.8C469.9 381 483.9 357.6 483.9 331.9 483.9 315.6 472.3 292.2 430.2 292.2zM240.8 346H173L154.3 434.8H224.4C280.5 434.8 294.5 409.1 294.5 385.7 294.6 369.4 282.9 346 240.8 346z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/blackberry.js
// module id = 6D0X
// module chunks = 144